////
/// ============================================================================
/// COMPONENT / Products Filters
/// ============================================================================
///
/// @group components
////

let filters = {

    // Inizializza il codice.
    init: function (container) {
        this.container = container;

        // Se il browser non supporta le fetch api, posso uscire subito.
        if (!window.fetch) {
            return;
        }

        // Il controllo dell’invio della form viene agganciato al container e non alla form
        // perché quando verrà eseguita la chiamata ajax, la form verrà sostituita. Praticamente
        // è un "delegate".
        this.container.addEventListener("submit", event => this.onSubmit(event));

        this.container.addEventListener("change", event => this.onChange(event));

        // Questo serve a gestire lo storico del browser (per andare avanti e indietro con le frecce).
        window.addEventListener("popstate", event => this.historyPop(event));
    },

    // Gestisce l’invio della form.
    onSubmit: function (event) {
        // Il listener è agganciato al container: quindi devo verificare se il "submit"
        // arriva effettivamente dalla form.
        let form = event.target.closest("form");

        if (!form) {
            return;
        }

        // Evito l’invio della form, altrimenti si ricarica la pagina.
        event.preventDefault();

        this.submit(form);
    },

    // Gestisce il cambio delle select e delle checkbox
    onChange: function (event) {
        let el = event.target.closest("select, input[type='checkbox']");

        if (!el || !this.container.contains(el)) {
            return;
        }

        let form = el.closest("form");

        if (form) {
            // Sarebbe molto più intelligente fare questo:
            // form.requestSubmit()
            // ma Safari non lo supporta!
            // @link https://developer.mozilla.org/en-US/docs/Web/API/HTMLFormElement/requestSubmit
            this.submit(form);
        }
    },

    // Esegue l’invio dei dati della form
    submit: function (form) {
        // Preparo la url per la chiamata ajax.
        let url = this.formToUrl(form);

        // Aggiorno l’url della pagina e carico i prodotti.
        this.historyPush(url);
        this.reload(url);
    },

    // Esegue la chiamata ajax e il caricamento dei prodotti.
    reload: function (url) {
        // Faccio partire lo spinner per l’effetto "loading".
        this.container.querySelector(".js-products-loader")?.classList.add("c-loader");

        fetch(url)
            .then(response => response.text())
            .then(html => {
                // Trucco banale: prendo il codice HTML della pagina, lo inserisco in un <div> temporaneo,
                // seleziono il frammento dei prodotti (filtri + prodotti + paginazione) e lo sostituisco
                // a quello della pagina corrente.
                let temp = document.createElement("DIV");
                temp.innerHTML = html;

                this.container.innerHTML = temp.querySelector(".js-products-filters").innerHTML;
            });
    },

    // Aggiorna l’url della pagina.
    historyPush: function (url) {
        let state = {
            name: "products-filters",
            url: url,
        };

        window.history.pushState(state, "", url);
    },

    // Gestisce lo storico del browser.
    historyPop: function (event) {
        if (event?.state?.name === "products-filters" && event?.state?.url) {
            this.reload(event.state.url);
        }
    },

    // Estrae la url dalla form.
    formToUrl: function (form) {
        let url = new URL(form.action);
        let formData = new FormData(form);

        // Converto la formData in array: ogni entry è un array con due elementi "nome" e "valore".
        [...formData.entries()]

            // Filtro i campi che hanno un valore, per ottenere una url più pulita.
            .filter(entry => "" !== entry[1])

            // Aggiungo i campi alla url.
            .map(entry => url.searchParams.append(entry[0], entry[1]));

        return url.toString();
    }
};

export default () => {
    document.querySelectorAll('.js-products-filters').forEach(container => filters.init(container));
};
